import React from "react";
import { Link } from "react-router-dom";
import { Constants } from "../../CommonMethhods/Constants";
import Formnav from "./FormNav";

function Signupform() {
  return (
    <>
      <div className="form-wrapper">
        <form
          className="form login-form login-page-form"
          id="register_page"
          name="userRegistrationForm"
        >
          <Formnav />
          <h2 className="form-title">{Constants.Create_Account}</h2>
          <h4 className="form-info">{Constants.Enter_details}</h4>
          <label htmlFor="name" className="form-label">
            {Constants.NAME}
            <span className="mandatory-label">*</span>
          </label>
          <input
            type="name"
            name="username"
            id="regName"
            className="form-input mb-4"
            placeholder="Enter your Full Name"
          />
          <label htmlFor="email" className="form-label">
            {Constants.EMAIL}
            <span className="mandatory-label">*</span>
          </label>
          <input
            type="text"
            name="emailid"
            id="regEmail"
            className="form-input mb-4"
            placeholder="Enter your Email ID"
          />

          <label htmlFor="email" className="form-label">
            {Constants.MOBILE_NUMBER}
            <span className="mandatory-label">*</span>
          </label>
          <input
            type="number"
            name="mobileno"
            id="regNumber"
            className="form-input mb-4"
            placeholder="Enter your Mobile Number"
          />
          <button className="form-submit" type="submit">
            {Constants.Sign_Up}
          </button>
          <span className="form-link">
            {Constants.Already_have_account}
            <Link to="/">Back to Login</Link>
          </span>
        </form>
      </div>
    </>
  );
}

export default Signupform;
